"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleProvider = LocaleProvider;
const jsx_runtime_1 = require("react/jsx-runtime");
const next_intl_1 = require("next-intl");
function LocaleProvider({ locale, messages, children }) {
    return ((0, jsx_runtime_1.jsx)(next_intl_1.IntlProvider, { locale: locale, messages: messages, children: children }));
}
